import { TriangleAlert } from "lucide-react";
import {
  EscalationMatrixParamsSchema,
  defaultEscalationMatrixParams,
  type EscalationMatrixParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { EscalationMatrixWidget } from "./Component.js";
import { EscalationMatrixExpandedEditor } from "./ExpandedEditor.js";

export const escalationMatrixDef: WidgetDef<EscalationMatrixParams> = {
  kind: "escalationMatrix",
  label: "Escalation Matrix",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 352, h: 324 },
  defaultParams: defaultEscalationMatrixParams,
  Component: EscalationMatrixWidget,
  ExpandedComponent: EscalationMatrixExpandedEditor,
  storage: "sql",
  schema: EscalationMatrixParamsSchema,
  accent: "amber",
  icon: TriangleAlert,
  subtitle: "Severity × response level — when to call in whom",
  defaultRoster: true,
  category: "single",
  layout: { col: 1, row: 0, width: 352, height: 300 },
  expandable: true,
  renderFooter: (data) => {
    return {
      left: `${data.cells.length} response${data.cells.length === 1 ? "" : "s"}`,
      right: null,
    };
  },
};

registerWidget(escalationMatrixDef);
